export default "__VITE_ASSET__CVkdvH1v__"